import {Directive, ElementRef, forwardRef, HostListener} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Directive({
  selector: 'eon-ui-input[type=text]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EonUiInputValueAccessorDirective),
      multi: true
    }
  ]
})
export class EonUiInputValueAccessorDirective implements ControlValueAccessor {

  private _value: string = "";

  constructor(private elementRef: ElementRef) {
  }

  onChange: any = () => {
  };
  onTouched: any = () => {
  };

  @HostListener('valueChanged', ['$event.detail'])
  listenForValueChange(value: string) {
    this.value = value;
  }

  get value(): string {
    return this._value;
  }

  set value(val: string) {
    if (val !== this._value) {
      this._value = val;
      this.onChange(this._value);
      this.onTouched();
      this.elementRef.nativeElement.value = val;
    }
  }

  writeValue(value: string) {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.elementRef.nativeElement.disabled = isDisabled
  }

}
